// src/components/FunMoneyCard.js
import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../utils/formatting';

const FunMoneyCard = ({ person, name, balance, allowance }) => {
    // Calculate percentage of allowance used/remaining
    const percentage = Math.min(100, Math.max(0, (balance / allowance) * 100));

    // Determine color based on balance percentage
    const getColorClass = () => {
        if (percentage > 75) return 'bg-green-500';
        if (percentage > 25) return 'bg-yellow-500';
        return 'bg-red-500';
    };

    return (
        <div className="bg-gray-50 rounded-lg p-4">
            <div className="text-lg font-medium mb-2">{name}</div>

            <div className="mb-3">
                <div className="text-2xl font-bold">{formatCurrency(balance)}</div>
                <div className="text-sm text-gray-600">of {formatCurrency(allowance)} monthly allowance</div>
            </div>

            <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div
                    className={`h-2.5 rounded-full ${getColorClass()}`}
                    style={{ width: `${percentage}%` }}
                ></div>
            </div>
            <div className="text-sm text-right mt-1 text-gray-600">
                {Math.round(percentage)}% remaining
            </div>
        </div>
    );
};

FunMoneyCard.propTypes = {
    person: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    balance: PropTypes.number.isRequired,
    allowance: PropTypes.number.isRequired
};

export default FunMoneyCard;